import React, { Dispatch, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import DefaultModal from "../default-modal/default-modal.component";
import stylesForm from "../../assets/styles/form.module.scss";

import { NewChatDataState } from "./new-chat.types";

import { ApplicationStore } from "~/app/application.store";
import chatActions from "~/app/chat/chat.actions";
import { setNewChatModalIsOpen } from "~/app/modals/modals.actions";

const NewChatModalComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const newChatModalIsOpen: boolean = useSelector((state: ApplicationStore) => state.modals.newChatModalIsOpen);

  const [chatData, setChatData]: [NewChatDataState, React.Dispatch<React.SetStateAction<NewChatDataState>>] =
    useState<NewChatDataState>({
      login: "",
      name: "",
      type: "default"
    });

  const handleSetNewChatModalIsOpen: (isOpen: boolean) => void = useCallback(
    (isOpen: boolean) => {
      dispatch(setNewChatModalIsOpen(isOpen));
    },
    [dispatch]
  );

  const createChat: (createChatData: { login: string; name: string; type: string }) => void = useCallback(
    (createChatData: { login: string; name: string; type: string }) => {
      dispatch(chatActions.createChat(createChatData));
    },
    [dispatch]
  );
  const handleChange: (target: { name: string; value: string }) => void = (target: {
    name: string;
    value: string;
  }): void => {
    setChatData({ ...chatData, [target.name]: target.value });
  };

  const handleCreateChat: () => void = (): void => {
    if (chatData.login !== "" && chatData.name !== "") {
      createChat({
        login: chatData.login,
        name: chatData.name,
        type: chatData.type
      });
    }
  };

  return (
    <DefaultModal
      title="New Contact"
      modalState={newChatModalIsOpen}
      setModalState={handleSetNewChatModalIsOpen}
      action={handleCreateChat}
    >
      <div className={stylesForm.inputGroup}>
        <input name="name" onChange={(e): void => handleChange(e.target)} placeholder="Name" />
      </div>
      <div className={stylesForm.inputGroup}>
        <input name="login" onChange={(e): void => handleChange(e.target)} placeholder="Login" />
      </div>
    </DefaultModal>
  );
};

export default NewChatModalComponent;
